import React from 'react';
export function OperatorTrainingSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-3032">
      <h2 className="text-2xl md:text-3xl font-bold text-[#1967a5] mb-6 border-b border-gray-200 pb-4" data-id="element-3033">
        EDM Machine Operator Training
      </h2>
      <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-3034">
        <div data-id="element-3035">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/EDM%20Images/EDM%20Training.jpg" alt="EDM Training" className="block w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-3036" />
        </div>
        <div className="space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-3037">
          <p data-id="element-3038">
            In today's world, technology, hardware, software and machine
            features are changing everyday. Even so, it is people and not just
            machines that are the most critical part of a company's success and
            rate of growth. In many shops the current WEDM operator never
            attended an official OEM machine training class. Often it is the
            case that the first operator showed the second operator what buttons
            to push and how to set up a part. Later, the third operator runs the
            machine from the second operator's "years of experience."
          </p>
          <p data-id="element-3039">
            Check to see if your supplier offers free operator training to
            companies purchasing a new wire EDM. Some offer it for as long as
            you own the machine. Sending an operator to one of the OEM demo
            centers for regular or advanced classes can turn your WEDM
            productivity in the right direction - not to mention improving the
            knowledge and morale of your WEDM department personnel.
          </p>
          <div className="pt-4" data-id="element-3040">
            <a href="https://www.gfms.com/country_US/en/customer-services/uptime/training.html" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline font-bold text-lg block" data-id="element-3041">
              GF Machining Solutions - AgieCharmilles - Operator Training →
            </a>
          </div>
        </div>
      </div>
    </div>;
}